module.exports = __webpack_public_path__ + "static/media/angle-down.0a3a92c9.svg";